import { VehicleImageWithMeta } from '@/catalog/types';
import {
  findImagesByCategory,
  FindImagesByCategoryOptions,
} from './find-images-by-category';

/**
 * Finds a single image by category and optionally by type
 * @param images Array of vehicle images to search through
 * @param category Category to filter by
 * @param options Additional options for filtering
 * @returns URL of the first matching image or undefined if none found
 */
export function findFirstImageByCategory(
  images: VehicleImageWithMeta[],
  category: string,
  options: Omit<FindImagesByCategoryOptions, 'limit'>
): string | undefined {
  const results = findImagesByCategory(images, category, { ...options, limit: 1 });
  return results[0];
}
